import { render, staticRenderFns } from "./fullCalendario.vue?vue&type=template&id=a90b385a"
import script from "./fullCalendario.vue?vue&type=script&lang=js"
export * from "./fullCalendario.vue?vue&type=script&lang=js"
import style0 from "./fullCalendario.vue?vue&type=style&index=0&id=a90b385a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports